
import { Vue, Prop, Component } from "vue-property-decorator";
import { getEnum } from "@/service/supplier-meta/api";
type StatusMap = { [x: string]: string };
let fetching = false;
const handlers: ((map: StatusMap) => void)[] = [];
@Component({})
export default class MonthCapacityStatus extends Vue {
  statusNameMap: { [x: string]: string } = {};
  loading = false;
  @Prop() value!: number | null;
  get isRejectStatus() {
    return this.value === 2;
  }
  async created() {
    this.loading = true;
    handlers.push((map: { [x: string]: string }) => {
      this.statusNameMap = map;
      this.loading = false;
    });
    if (!fetching) {
      fetching = true;
      const res = await getEnum(
        "SupplierClothesCapacityStatusEnum",
        true
      ).catch(() => null);
      fetching = false;
      const statusMap: StatusMap = {};
      if (res && Array.isArray(res.result)) {
        res.result.forEach((ele) => {
          statusMap[ele.code] = ele.desc;
        });
      }
      handlers.forEach((handler) => {
        handler(statusMap);
      });
    }
  }
  get getStatusName() {
    if (this.value === undefined || this.value === null) {
      return "";
    } else {
      return this.statusNameMap[this.value] || "";
    }
  }
}
